import { IWatrTrip } from '@nkr/models/watr-trip';
import { ILineItem } from './line-item.types';

export interface ITripGroup {
    id: number;
    name: string;
    type: string;
    startDate: string;
    endDate: string;
    status: string;
    trip: IWatrTrip;
    lineItems: ILineItem[];
    travelRequestId: number;
}

